import { render } from "./MailForm.vue?vue&type=template&id=f124cd1c&ts=true"
import script from "./MailForm.vue?vue&type=script&lang=ts"
export * from "./MailForm.vue?vue&type=script&lang=ts"

import "./MailForm.vue?vue&type=style&index=0&id=f124cd1c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__